import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { hexToRgb } from '../../common/utils';

const S = {
  Button: styled.button`
    display: flex;
    align-items: center;
    min-width: 140px;
    cursor: pointer;
    outline: none;
    :hover i {
      color: red;
      background-color: ${({ theme }) => hexToRgb(theme.palette.secondary.main, 0.87)};
    }
    ${({ active }) => active && css`
      :hover i {
        background-color: transparent;
        color: blue;
      }
    `}
  `,
  Icon: styled.i`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: 4px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.24);
    transition:
      background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    ${({ active }) => active && css`
      background-color: transparent;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.32);
    `}
  `,
  Add: styled(({ active, ...otherProps }) => <Add {...otherProps} />)`
    color: ${({ theme }) => theme.palette.secondary.contrastText};
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    transition:
      transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    ${({ active, theme }) => active && css`
      transform: rotate(45deg);
      color: ${theme.palette.grey[600]};
    `}
  `,
  Typography: styled(({ active, ...otherProps }) => <Typography {...otherProps} />).attrs({
    component: 'em',
  })`
    margin-left: 8px;
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: 500;
    font-style: normal;
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    ${({ active, theme }) => active && css`
      color: ${theme.palette.grey[600]};
    `}
  `,
};

const StepGuideButton = ({
  children, active, onClick, ...otherProps
}) => (
  <S.Button
    color="secondary"
    variant="contained"
    active={active}
    onClick={onClick}
    {...otherProps}
  >
    <S.Icon active={active}>
      <S.Add active={active} />
    </S.Icon>
    <S.Typography active={active}>
      {children}
    </S.Typography>
  </S.Button>
);

StepGuideButton.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  onClick: PropTypes.func,
};
StepGuideButton.defaultProps = {
  children: undefined,
  active: false,
  onClick: () => {},
};

StepGuideButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

StepGuideButton.defaultProps = {
  type: 'button',
};

export default StepGuideButton;
